var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZkSharkBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 461.4 461.4",
    style: {
      enableBackground: "new 0 0 461.4 461.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#BABABA;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#5EA7FF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.3,370.2c0,0,86.2-125.7,4.1-370c0,0,331-19.4,318.5,397.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,310.2l34.5,34c12.8,12.6,32.8,11.6,44.8-2.2l14.2-16.3c12-13.8,31.4-13.8,43.4,0l14.2,16.3 c12,13.8,31.4,13.8,43.4,0l14.2-16.3c12-13.8,31.4-13.8,43.4,0l14.2,16.3c12,13.8,31.4,13.8,43.4,0l14.2-16.3 c12-13.8,31.4-13.8,43.4,0L382,342c12,13.8,32,14.8,44.8,2.2l34.5-34v151.2H0V310.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZkSharkBadge);
export default __webpack_public_path__ + "static/media/zk_shark_badge.31f74a3fc8287ea66b83e16ded8d5182.svg";
export { ForwardRef as ReactComponent };